export interface SnippetPart {
  text: string
  highlight: boolean
}

/** Split a search snippet where matched terms are wrapped as [[term]]. Unclosed markers stay literal. */
export function parseSnippet(snippet: string): SnippetPart[] {
  const parts: SnippetPart[] = []
  let rest = snippet
  const push = (text: string, highlight: boolean) => {
    if (!text) return
    const last = parts[parts.length - 1]
    if (last && last.highlight === highlight) last.text += text
    else parts.push({ text, highlight })
  }
  while (rest.length) {
    const open = rest.indexOf('[[')
    if (open === -1) break
    const close = rest.indexOf(']]', open + 2)
    if (close === -1) break
    push(rest.slice(0, open), false)
    const term = rest.slice(open + 2, close)
    if (term) push(term, true)
    rest = rest.slice(close + 2)
  }
  push(rest, false)
  return parts
}
